query searchPreviewEmployees($hashCode: String!, $search: String, $limit: Int) {
  previewEmployeeSearch(hashCode: $hashCode, search: $search, limit: $limit) {
    id
    firstName
    lastName
  }
}
